<template>
    <a class="blackCardDiscout" :href="location" >
        <div>
            <p>
                <b>途牛黑卡会员</b>
                <i class="dot">.</i>
                <span>尊享<i>1%</i>立减优惠</span>
            </p>
        </div>
        <span class="checkDetail">查看详情</span>
        <i class="arrow"></i>
    </a>
</template>

<script>
export default {
    props:{
        location: {
            type: String,
            default: 'javascript:;'
        },
    },
    methods: {
        openMore: function() {
            this.$emit('more');
        }
    }
}
</script>

<style lang="scss">
.blackCardDiscout {
    display: block;
    position: relative;
    background: #fff;
    font-size: 14px;
    line-height: 24px;
    touch-action: manipulation;
    p{
        background: linear-gradient(to right,#f9f3ea,#fffdfb);
        height: 38px;
        line-height: 38px;
    }
    b {
        display: inline-block;
        margin-left: 18px;
        padding-left: 22px;
        color: #381807;
        font-size: 13px;
        vertical-align: middle;
        background: url(../assets/blackCard.png) no-repeat;
        background-size: 17px;
        background-position: 0 9px;
    }
    .dot {
        position: relative;
        top: -6px;
        padding: 0 5px;
        display: inline-block;
        vertical-align: middle;
        color: #381807;
        font-size: 20px;
    }
    span {
        display: inline-block;
        vertical-align: middle;
        font-size: 13px;
        color: #666666;
        i {
            font-style: normal;
            color: #FF6436;
        }
    }
    .checkDetail{
        position: absolute;
        right: 30px;
        top: 8px;
        font-size: 13px;
        color: #A5A5A5;
    }
    .arrow {
        position: absolute;
        right: 6px;
        top: 50%;
        width: 24px;
        height: 24px;
        transform: translate(0, -50%) scale(0.7);

        &:before,
        &:after {
            content: " ";
            position: absolute;
            left: 50%;
            top: 50%;
            width: 50%;
            height: 2px;
            margin: -1px 0 0 -25%;
            background: #c2c6cc;
        }

        &:before {
            transform: translate(0, -4px) rotate(45deg);
        }

        &:after {
            transform: translate(0, 4px) rotate(-45deg);
        }
    }
}
</style>




// WEBPACK FOOTER //
// blackCardDiscout.vue